__turbopack_context__.v({
  "contents": "MenuDrawer-module__mudQUq__contents",
  "drawer": "MenuDrawer-module__mudQUq__drawer",
  "footer": "MenuDrawer-module__mudQUq__footer",
});
